import { getUserClassPath } from 'approot/classes/classes.apollo';
import {
  NotificationActions,
  NotificationContent,
  NotificationTip,
  NotificationTipText,
} from 'approot/shared/notifications/notification-tip.style';
import { SecondaryButtonAndIconLink } from 'approot/shared/styles/buttons/secondary-button.style';
import { PRIVATE_MY_STUDENTS } from 'global/private-routes.constants';
import { openNewTab } from 'approot/shared/logic/open-new-tab';
import IconExpand from 'approot/shared/icons/icon-expand';
import { getRegionalisedLink } from 'approot/shared/logic/get-regionalised-link';
import { EVENT_TARGET_TYPE_BANNER } from 'approot/shared/data-tracker/data-events.constants';
import { addStudentsPushDataTrackingEvent } from 'approot/teacher-student/logic/add-students-push-data-tracking-event';

const AssignNotificationActivities = ({
  hasStudents,
}: {
  hasStudents: boolean;
}) => {
  return (
    <NotificationTip $noMaxWidth $marginBottom={16}>
      {hasStudents ? (
        <NotificationTipText marginBottom={0}>
          You can collect student responses in these Digital Slides!
        </NotificationTipText>
      ) : (
        <>
          <NotificationContent>
            <NotificationTipText>
              Your class has read-only access to these Digital Slides. To start
              collecting student responses add your students.
            </NotificationTipText>
            <NotificationActions>
              <SecondaryButtonAndIconLink
                aria-label="Add Students - opens in a new tab"
                $isSmall
                data-testid="btn-add-students"
                to={getRegionalisedLink(getUserClassPath(PRIVATE_MY_STUDENTS))}
                onClick={e => {
                  e.preventDefault();
                  addStudentsPushDataTrackingEvent({
                    targetType: EVENT_TARGET_TYPE_BANNER,
                    targetIdentifier: 'assign-modal',
                  });
                  openNewTab(
                    getRegionalisedLink(getUserClassPath(PRIVATE_MY_STUDENTS))
                  );
                }}
              >
                Add Students
                <IconExpand />
              </SecondaryButtonAndIconLink>
            </NotificationActions>
          </NotificationContent>
        </>
      )}
    </NotificationTip>
  );
};

export default AssignNotificationActivities;
